import React, { useEffect, useState } from "react";
import {
    loadCaptchaEnginge,
    validateCaptcha,
    LoadCanvasTemplateNoReload,
} from "react-simple-captcha";
import Header from "./Header";

interface Certificate {
    number: string;
    title: string;
    duration: string;
    status: string;
    name: string;
}

const CertificateValidation: React.FC = () => {
    const [growniverse, setGrowniverse] = useState("");
    const [email, setEmail] = useState("");
    const [dob, setDob] = useState("");
    const [screen, setScreen] = useState<"entry" | "list">("entry");
    const [isValid, setIsValid] = useState<boolean | null>(null);
    const [captchaInput, setCaptchaInput] = useState("");
    const [invalidCaptcha, setInvalidCaptcha] = useState(false);

    const certificates: Certificate[] = [
        {
            number: "IN-291201",
            title: "Internship Certificate - Sales and Marketing",
            duration: "8 June 2026 – 24 July 2026",
            status: "Completed",
            name: "Navneet Kumar",
        },
    ];

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!validateCaptcha(captchaInput)) {
            setInvalidCaptcha(true);
            return;
        }

        const formattedDob = dob
            ? new Date(dob).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
              })
            : "";

        if (
            growniverse === "G100210" &&
            email === "navneetrai050@gmail.com" &&
            formattedDob === "2 May 1999" &&
            captchaInput
        ) {
            setIsValid(true);
            setScreen("list");
        } else {
            setIsValid(false);
        }
    };

    const handleBack = () => {
        window.location.reload();
    };

    useEffect(() => {
        loadCaptchaEnginge(6);

        const styles = `
            @keyframes certificateFadeIn {
                from {
                    opacity: 0;
                    transform: translateY(30px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }

            @keyframes certificateGlow {
                0%, 100% {
                    opacity: 0.35;
                }
                50% {
                    opacity: 0.7;
                }
            }

            @keyframes certificateScan {
                0% {
                    transform: translateX(-100%);
                }
                100% {
                    transform: translateX(100%);
                }
            }

            .certificate-page *,
            .certificate-page *::before,
            .certificate-page *::after {
                box-sizing: border-box;
            }

            .certificate-input::placeholder {
                color: #64748b;
            }

            .certificate-input:focus {
                outline: none !important;
                border-color: rgba(0,246,255,0.7) !important;
                box-shadow:
                    0 0 0 3px rgba(0,246,255,0.06),
                    0 0 25px rgba(0,246,255,0.10) !important;
            }

            .certificate-submit:hover {
                transform: translateY(-2px);
                box-shadow:
                    0 10px 35px rgba(0,246,255,0.18),
                    0 0 25px rgba(0,246,255,0.15) !important;
            }

            .certificate-back:hover {
                transform: translateY(-2px);
                border-color: rgba(0,246,255,0.5) !important;
                color: #00f6ff !important;
            }

            .certificate-page .captcha canvas {
                max-width: 100%;
            }

            @media (max-width: 768px) {
                .certificate-page {
                    padding: 30px 15px !important;
                }

                .certificate-card {
                    padding: 25px !important;
                }

                .certificate-title {
                    font-size: 28px !important;
                }
            }
        `;

        const styleSheet = document.createElement("style");
        styleSheet.innerText = styles;
        document.head.appendChild(styleSheet);

        return () => {
            document.head.removeChild(styleSheet);
        };
    }, []);

    return (
        <>
            <Header />

            <section
                className="certificate-page"
                style={{
                    position: "relative",
                    minHeight: "calc(100vh - 80px)",
                    overflow: "hidden",

                    background:
                        "linear-gradient(135deg, #050810 0%, #080d19 48%, #0b1020 100%)",

                    padding: "70px 20px",

                    color: "#ffffff",
                }}
            >
                {/* ============================================
                    BACKGROUND GRID
                ============================================ */}

                <div
                    style={{
                        position: "absolute",
                        inset: 0,

                        backgroundImage:
                            "linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px)",

                        backgroundSize: "35px 35px",

                        opacity: 0.35,

                        pointerEvents: "none",
                    }}
                />

                {/* ============================================
                    CYAN GLOW
                ============================================ */}

                <div
                    style={{
                        position: "absolute",

                        width: "450px",
                        height: "450px",

                        left: "-220px",
                        top: "-180px",

                        borderRadius: "50%",

                        background:
                            "rgba(0,246,255,0.08)",

                        filter: "blur(110px)",

                        animation:
                            "certificateGlow 5s ease-in-out infinite",

                        pointerEvents: "none",
                    }}
                />

                {/* ============================================
                    PURPLE GLOW
                ============================================ */}

                <div
                    style={{
                        position: "absolute",

                        width: "450px",
                        height: "450px",

                        right: "-220px",
                        bottom: "-180px",

                        borderRadius: "50%",

                        background:
                            "rgba(139,92,255,0.10)",

                        filter: "blur(110px)",

                        animation:
                            "certificateGlow 6s ease-in-out infinite",

                        pointerEvents: "none",
                    }}
                />

                {/* ============================================
                    TOP SCAN LINE
                ============================================ */}

                <div
                    style={{
                        position: "absolute",

                        top: 0,
                        left: 0,

                        width: "100%",
                        height: "1px",

                        overflow: "hidden",

                        background:
                            "linear-gradient(90deg, transparent, rgba(0,246,255,0.5), transparent)",

                        pointerEvents: "none",
                    }}
                >
                    <div
                        style={{
                            width: "35%",
                            height: "100%",

                            background:
                                "linear-gradient(90deg, transparent, #00f6ff, transparent)",

                            animation:
                                "certificateScan 5s linear infinite",
                        }}
                    />
                </div>

                {/* ============================================
                    CONTENT
                ============================================ */}

                <div
                    className="container"
                    style={{
                        position: "relative",
                        zIndex: 2,

                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    {/* ========================================
                        ENTRY SCREEN
                    ======================================== */}

                    {screen === "entry" && (
                        <div
                            className="certificate-card"
                            style={{
                                width: "100%",
                                maxWidth: "650px",

                                padding: "42px",

                                borderRadius: "22px",

                                background:
                                    "linear-gradient(145deg, rgba(18,25,40,0.96), rgba(7,11,20,0.98))",

                                border:
                                    "1px solid rgba(0,246,255,0.16)",

                                boxShadow:
                                    "0 25px 80px rgba(0,0,0,0.55), 0 0 40px rgba(0,246,255,0.05)",

                                animation:
                                    "certificateFadeIn 0.7s ease",
                            }}
                        >
                            {/* TOP NEON LINE */}

                            <div
                                style={{
                                    height: "2px",

                                    width: "55%",

                                    margin:
                                        "0 auto 30px",

                                    background:
                                        "linear-gradient(90deg, transparent, #00f6ff, #8b5cff, transparent)",

                                    boxShadow:
                                        "0 0 15px rgba(0,246,255,0.7)",
                                }}
                            />

                            {/* HEADER */}

                            <div
                                style={{
                                    textAlign: "center",
                                    marginBottom: "35px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "inline-flex",

                                        alignItems: "center",

                                        gap: "8px",

                                        padding:
                                            "7px 16px",

                                        borderRadius:
                                            "30px",

                                        border:
                                            "1px solid rgba(0,246,255,0.20)",

                                        background:
                                            "rgba(0,246,255,0.035)",

                                        color:
                                            "#00f6ff",

                                        fontSize:
                                            "10px",

                                        fontWeight: 700,

                                        letterSpacing:
                                            "2px",

                                        textTransform:
                                            "uppercase",

                                        marginBottom:
                                            "15px",
                                    }}
                                >
                                    <span
                                        style={{
                                            width: "6px",
                                            height: "6px",

                                            borderRadius:
                                                "50%",

                                            background:
                                                "#00f6ff",

                                            boxShadow:
                                                "0 0 10px #00f6ff",
                                        }}
                                    />

                                    Growniverse Verification
                                </div>

                                <h1
                                    className="certificate-title"
                                    style={{
                                        margin: 0,

                                        color: "#ffffff",

                                        fontSize:
                                            "clamp(28px, 4vw, 40px)",

                                        fontWeight: 800,

                                        letterSpacing:
                                            "-0.5px",

                                        textShadow:
                                            "0 0 20px rgba(255,255,255,0.10), 0 0 35px rgba(0,246,255,0.08)",
                                    }}
                                >
                                    Certificate Validation
                                </h1>

                                <div
                                    style={{
                                        width: "70px",

                                        height: "3px",

                                        margin:
                                            "15px auto 0",

                                        borderRadius:
                                            "10px",

                                        background:
                                            "linear-gradient(90deg, transparent, #00f6ff, transparent)",

                                        boxShadow:
                                            "0 0 12px rgba(0,246,255,0.6)",
                                    }}
                                />

                                <p
                                    style={{
                                        margin:
                                            "18px auto 0",

                                        maxWidth:
                                            "500px",

                                        color:
                                            "#94a3b8",

                                        fontSize:
                                            "13px",

                                        lineHeight:
                                            1.7,
                                    }}
                                >
                                    Verify your Growniverse certificate
                                    using your registered details.
                                </p>
                            </div>

                            <form onSubmit={handleSubmit}>
                                {/* GROWNIVERSE ID */}

                                <label style={labelStyle}>
                                    Growniverse ID
                                </label>

                                <input
                                    type="text"
                                    value={growniverse}
                                    onChange={(e) =>
                                        setGrowniverse(
                                            e.target.value
                                        )
                                    }
                                    required
                                    className="certificate-input"
                                    placeholder="Enter your Growniverse ID"
                                    style={inputStyle}
                                />

                                {/* EMAIL */}

                                <label style={labelStyle}>
                                    Email ID
                                </label>

                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) =>
                                        setEmail(
                                            e.target.value
                                        )
                                    }
                                    required
                                    className="certificate-input"
                                    placeholder="Enter your registered email"
                                    style={inputStyle}
                                />

                                {/* DOB */}

                                <label style={labelStyle}>
                                    Date of Birth
                                </label>

                                <input
                                    type="date"
                                    value={dob}
                                    onChange={(e) =>
                                        setDob(
                                            e.target.value
                                        )
                                    }
                                    required
                                    className="certificate-input"
                                    style={inputStyle}
                                />

                                {/* CAPTCHA */}

                                <div
                                    style={{
                                        margin:
                                            "22px 0 25px",

                                        padding:
                                            "18px",

                                        borderRadius:
                                            "14px",

                                        border:
                                            "1px solid rgba(255,255,255,0.07)",

                                        background:
                                            "rgba(255,255,255,0.025)",
                                    }}
                                >
                                    <div
                                        style={{
                                            color:
                                                "#94a3b8",

                                            fontSize:
                                                "11px",

                                            fontWeight:
                                                700,

                                            letterSpacing:
                                                "1px",

                                            textTransform:
                                                "uppercase",

                                            marginBottom:
                                                "12px",
                                        }}
                                    >
                                        Security Verification
                                    </div>

                                    <div
                                        style={{
                                            padding:
                                                "12px",

                                            marginBottom:
                                                "12px",

                                            borderRadius:
                                                "10px",

                                            background:
                                                "rgba(0,0,0,0.20)",

                                            display:
                                                "flex",

                                            justifyContent:
                                                "center",
                                        }}
                                    >
                                        <LoadCanvasTemplateNoReload />
                                    </div>

                                    <input
                                        type="text"
                                        placeholder="Enter Captcha"
                                        value={
                                            captchaInput
                                        }
                                        onChange={(e) => {
                                            setCaptchaInput(
                                                e.target.value
                                            );

                                            setInvalidCaptcha(
                                                false
                                            );
                                        }}
                                        required
                                        className="certificate-input"
                                        style={{
                                            ...inputStyle,
                                            marginBottom: 0,
                                        }}
                                    />

                                    {invalidCaptcha && (
                                        <div
                                            style={{
                                                marginTop:
                                                    "8px",

                                                color:
                                                    "#ff6b81",

                                                fontSize:
                                                    "12px",

                                                fontWeight:
                                                    600,
                                            }}
                                        >
                                            ✕ Invalid Captcha
                                        </div>
                                    )}
                                </div>

                                {/* SUBMIT */}

                                <button
                                    type="submit"
                                    className="certificate-submit"
                                    style={buttonStyle}
                                >
                                    <span>
                                        VERIFY CERTIFICATE
                                    </span>

                                    <span
                                        style={{
                                            marginLeft:
                                                "8px",
                                            color:
                                                "#00f6ff",
                                        }}
                                    >
                                        →
                                    </span>
                                </button>
                            </form>

                            {/* ERROR */}

                            {isValid === false && (
                                <div
                                    style={{
                                        marginTop:
                                            "22px",

                                        padding:
                                            "18px",

                                        borderRadius:
                                            "12px",

                                        background:
                                            "rgba(255,70,90,0.06)",

                                        border:
                                            "1px solid rgba(255,70,90,0.25)",

                                        color:
                                            "#ff8a9b",

                                        textAlign:
                                            "center",

                                        boxShadow:
                                            "0 0 25px rgba(255,70,90,0.05)",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize:
                                                "25px",

                                            marginBottom:
                                                "5px",
                                        }}
                                    >
                                        ✕
                                    </div>

                                    <strong
                                        style={{
                                            fontSize:
                                                "14px",

                                            letterSpacing:
                                                "0.5px",
                                        }}
                                    >
                                        Certificate Not Found
                                    </strong>

                                    <p
                                        style={{
                                            margin:
                                                "6px 0 0",

                                            fontSize:
                                                "11px",

                                            color:
                                                "#a78b94",
                                        }}
                                    >
                                        Please check your
                                        credentials and try again.
                                    </p>
                                </div>
                            )}
                        </div>
                    )}

                    {/* ========================================
                        CERTIFICATE LIST
                    ======================================== */}

                    {screen === "list" && (
                        <div
                            className="certificate-card"
                            style={{
                                width: "100%",
                                maxWidth: "750px",

                                padding: "42px",

                                borderRadius: "22px",

                                background:
                                    "linear-gradient(145deg, rgba(18,25,40,0.96), rgba(7,11,20,0.98))",

                                border:
                                    "1px solid rgba(0,246,255,0.16)",

                                boxShadow:
                                    "0 25px 80px rgba(0,0,0,0.55), 0 0 40px rgba(0,246,255,0.05)",

                                animation:
                                    "certificateFadeIn 0.7s ease",
                            }}
                        >
                            {/* TOP LINE */}

                            <div
                                style={{
                                    height: "2px",

                                    width: "55%",

                                    margin:
                                        "0 auto 30px",

                                    background:
                                        "linear-gradient(90deg, transparent, #00f6ff, #8b5cff, transparent)",

                                    boxShadow:
                                        "0 0 15px rgba(0,246,255,0.7)",
                                }}
                            />

                            {/* TITLE */}

                            <div
                                style={{
                                    textAlign: "center",
                                    marginBottom: "30px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "inline-flex",

                                        padding:
                                            "7px 16px",

                                        borderRadius:
                                            "30px",

                                        border:
                                            "1px solid rgba(0,246,255,0.20)",

                                        background:
                                            "rgba(0,246,255,0.035)",

                                        color:
                                            "#00f6ff",

                                        fontSize:
                                            "10px",

                                        fontWeight:
                                            700,

                                        letterSpacing:
                                            "2px",

                                        textTransform:
                                            "uppercase",

                                        marginBottom:
                                            "15px",
                                    }}
                                >
                                    ✓ Verification Successful
                                </div>

                                <h1
                                    className="certificate-title"
                                    style={{
                                        margin: 0,

                                        color:
                                            "#ffffff",

                                        fontSize:
                                            "clamp(28px, 4vw, 40px)",

                                        fontWeight:
                                            800,
                                    }}
                                >
                                    Your Certificates
                                </h1>

                                <div
                                    style={{
                                        width: "70px",

                                        height: "3px",

                                        margin:
                                            "15px auto 0",

                                        background:
                                            "linear-gradient(90deg, transparent, #00f6ff, transparent)",

                                        boxShadow:
                                            "0 0 12px rgba(0,246,255,0.6)",
                                    }}
                                />
                            </div>

                            {/* CERTIFICATE */}

                            {certificates.map(
                                (cert, idx) => (
                                    <div
                                        key={idx}
                                        style={{
                                            position:
                                                "relative",

                                            overflow:
                                                "hidden",

                                            padding:
                                                "28px",

                                            borderRadius:
                                                "18px",

                                            background:
                                                "linear-gradient(145deg, rgba(0,246,255,0.045), rgba(139,92,255,0.035))",

                                            border:
                                                "1px solid rgba(0,246,255,0.18)",

                                            boxShadow:
                                                "0 15px 45px rgba(0,0,0,0.35), 0 0 25px rgba(0,246,255,0.04)",
                                        }}
                                    >
                                        {/* CERTIFICATE TOP LINE */}

                                        <div
                                            style={{
                                                position:
                                                    "absolute",

                                                top: 0,

                                                left:
                                                    "15%",

                                                right:
                                                    "15%",

                                                height:
                                                    "2px",

                                                background:
                                                    "linear-gradient(90deg, transparent, #00f6ff, #8b5cff, transparent)",

                                                boxShadow:
                                                    "0 0 12px #00f6ff",
                                            }}
                                        />

                                        <div
                                            style={{
                                                display:
                                                    "flex",

                                                justifyContent:
                                                    "space-between",

                                                alignItems:
                                                    "flex-start",

                                                gap:
                                                    "20px",

                                                marginBottom:
                                                    "25px",
                                            }}
                                        >
                                            <div>
                                                <div
                                                    style={{
                                                        color:
                                                            "#00f6ff",

                                                        fontSize:
                                                            "10px",

                                                        fontWeight:
                                                            700,

                                                        letterSpacing:
                                                            "1.5px",

                                                        textTransform:
                                                            "uppercase",

                                                        marginBottom:
                                                            "8px",
                                                    }}
                                                >
                                                    Certificate
                                                    Verified
                                                </div>

                                                <h2
                                                    style={{
                                                        color:
                                                            "#ffffff",

                                                        fontSize:
                                                            "20px",

                                                        lineHeight:
                                                            1.4,

                                                        fontWeight:
                                                            700,

                                                        margin:
                                                            0,
                                                    }}
                                                >
                                                    📜{" "}
                                                    {
                                                        cert.title
                                                    }
                                                </h2>
                                            </div>

                                            <div
                                                style={{
                                                    flexShrink:
                                                        0,

                                                    padding:
                                                        "7px 12px",

                                                    borderRadius:
                                                        "20px",

                                                    background:
                                                        "rgba(0,246,255,0.08)",

                                                    border:
                                                        "1px solid rgba(0,246,255,0.25)",

                                                    color:
                                                        "#00f6ff",

                                                    fontSize:
                                                        "10px",

                                                    fontWeight:
                                                        700,

                                                    letterSpacing:
                                                        "1px",
                                                }}
                                            >
                                                ✓ COMPLETED
                                            </div>
                                        </div>

                                        {/* DETAILS */}

                                        <div
                                            style={{
                                                display:
                                                    "grid",

                                                gridTemplateColumns:
                                                    "repeat(2, minmax(0, 1fr))",

                                                gap:
                                                    "14px",

                                                marginTop:
                                                    "20px",
                                            }}
                                        >
                                            <CertificateDetail
                                                label="Name"
                                                value={
                                                    cert.name
                                                }
                                            />

                                            <CertificateDetail
                                                label="Certificate Number"
                                                value={
                                                    cert.number
                                                }
                                            />

                                            <CertificateDetail
                                                label="Duration"
                                                value={
                                                    cert.duration
                                                }
                                            />

                                            <CertificateDetail
                                                label="Status"
                                                value={
                                                    cert.status
                                                }
                                            />
                                        </div>
                                    </div>
                                )
                            )}

                            {/* BACK */}

                            <button
                                onClick={handleBack}
                                className="certificate-back"
                                style={{
                                    width: "100%",

                                    marginTop:
                                        "25px",

                                    padding:
                                        "13px",

                                    borderRadius:
                                        "10px",

                                    border:
                                        "1px solid rgba(255,255,255,0.10)",

                                    background:
                                        "rgba(255,255,255,0.025)",

                                    color:
                                        "#cbd5e1",

                                    fontSize:
                                        "12px",

                                    fontWeight:
                                        700,

                                    letterSpacing:
                                        "1px",

                                    cursor:
                                        "pointer",

                                    transition:
                                        "all 0.25s ease",
                                }}
                            >
                                ← BACK TO VALIDATION
                            </button>
                        </div>
                    )}
                </div>

                {/* ============================================
                    BOTTOM LINE
                ============================================ */}

                <div
                    style={{
                        position: "absolute",

                        bottom: 0,

                        left: "20%",
                        right: "20%",

                        height: "1px",

                        background:
                            "linear-gradient(90deg, transparent, rgba(0,246,255,0.45), transparent)",

                        pointerEvents: "none",
                    }}
                />
            </section>
        </>
    );
};

/* ============================================================
   SMALL CERTIFICATE DETAIL COMPONENT
============================================================ */

interface CertificateDetailProps {
    label: string;
    value: string;
}

const CertificateDetail: React.FC<CertificateDetailProps> = ({
    label,
    value,
}) => {
    return (
        <div
            style={{
                padding: "15px",

                borderRadius: "10px",

                background:
                    "rgba(255,255,255,0.025)",

                border:
                    "1px solid rgba(255,255,255,0.06)",
            }}
        >
            <div
                style={{
                    color: "#64748b",

                    fontSize: "9px",

                    fontWeight: 700,

                    letterSpacing: "1.2px",

                    textTransform: "uppercase",

                    marginBottom: "6px",
                }}
            >
                {label}
            </div>

            <div
                style={{
                    color: "#e2e8f0",

                    fontSize: "13px",

                    fontWeight: 600,

                    lineHeight: 1.5,
                }}
            >
                {value}
            </div>
        </div>
    );
};

/* ============================================================
   STYLES
============================================================ */

const labelStyle: React.CSSProperties = {
    display: "block",

    marginBottom: "8px",

    color: "#cbd5e1",

    fontSize: "11px",

    fontWeight: 700,

    letterSpacing: "0.8px",

    textTransform: "uppercase",
};

const inputStyle: React.CSSProperties = {
    width: "100%",

    padding: "13px 15px",

    marginBottom: "20px",

    borderRadius: "10px",

    border:
        "1px solid rgba(255,255,255,0.10)",

    background:
        "rgba(255,255,255,0.035)",

    color: "#ffffff",

    fontSize: "13px",

    transition: "all 0.25s ease",
};

const buttonStyle: React.CSSProperties = {
    width: "100%",

    padding: "14px 20px",

    border: "1px solid rgba(0,246,255,0.45)",

    borderRadius: "10px",

    background:
        "linear-gradient(135deg, rgba(0,246,255,0.10), rgba(139,92,255,0.12))",

    color: "#ffffff",

    cursor: "pointer",

    fontSize: "12px",

    fontWeight: 800,

    letterSpacing: "1.2px",

    transition: "all 0.25s ease",

    boxShadow:
        "0 0 20px rgba(0,246,255,0.07)",
};

export default CertificateValidation;